<template>
  <tr class="coupon">
    <td class="pr-4">
      <div class="h-8"></div>
    </td>
    <td class="pr-4" colspan="4">
      <Code
        class="whitespace-nowrap mr-2"
        chunk="2"
        :value="code"
        :color="info.theme ?? 'default'"
      />
      <span class="text-gray-700 text-sm">
        {{ name }}
      </span>
      <template v-if="info.category">
        <span class="text-sm text-gray-700">,&nbsp;</span>
        <span class="text-sm" :class="color">
          {{ info.category }}
        </span>
      </template>
      <template v-if="info.text">
        <span class="text-sm text-gray-700">, {{ info.text }}</span>
      </template>
    </td>
    <td class="collapse pr-2">
      <Link
        v-if="abilities.delete"
        :href="route('cart.lines.discounts.destroy', [line, id])"
        preserve-scroll
        method="delete"
        class="w-7 h-7 flex text-gray-700 hover:text-gray-900"
        as="button"
      >
        <Icon type="cancel" class="m-auto" />
      </Link>
    </td>
    <td class="collapse text-right whitespace-nowrap">
      <strong class="text-lg" :class="color">
        {{ formatPrice(-applied) }}
      </strong>
    </td>
  </tr>
</template>

<script>
export default {
  inheritAttrs: false,
}
</script>

<script setup>
import Code from 'Web/Shared/Code.vue';
import Icon from 'Web/Shared/Icon.vue';
import Link from 'Web/Shared/Link.vue';
import formatPrice from '@/helpers/formatPrice';
import rescue from '@/helpers/rescue';
import { computed } from 'vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  line: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  code: {
    type: [Number, String],
    required: true,
  },
  info: {
    type: String,
    required: true,
  },
  applied: {
    type: [Number, String],
    required: true,
  },
  abilities: {
    type: Object,
    required: true,
  },
});

const info = computed(() => rescue(() => JSON.parse(props.info), {
  text: info,
}));

const color = computed(() => ({
  default: 'text-blue-500',
  pga:     'text-pga-500',
  pgb:     'text-pgb-500',
  pgc:     'text-pgc-500',
  pgd:     'text-pgd-500',
}[info.value.theme ?? 'default']));

</script>

<style scoped>

tr.coupon td {
  padding-bottom: 1rem;
}

</style>
